import Joi from "joi";

const VisitTypeSchema = Joi.object({
  name: Joi.string().trim().required().messages({
    "string.empty": "Name is required.",
  }),
  visitType: Joi.string().trim().required().messages({
    "string.empty": "Visit Type is required.",
  }),
}).unknown(true);

export default VisitTypeSchema;
